import { theme } from '@nicejob-library/design-system';
import {
    AuthCard,
    AuthCardText,
    AuthContainer,
    AuthContent,
    AuthFooter,
} from '@nicejob-library/design-system/authentication';
import { translate } from '@nicejob-library/internationalization';
import React, { ReactElement } from 'react';
import { ThemeProvider } from 'styled-components';
import { IResetPasswordDonePageProps } from '../../../types/login.types';
import { HeaderLogo } from '../components/common/HeaderLogo';
import { LoginLink } from '../components/common/LoginLink';

export function ResetPasswordDonePage(props: IResetPasswordDonePageProps): ReactElement {
    const { branding, language, is_multiple_platforms } = props;

    return (
        <ThemeProvider theme={theme}>
            <AuthContainer>
                <HeaderLogo branding={branding} />

                <AuthContent>
                    <AuthCard>
                        <AuthCardText>
                            {is_multiple_platforms
                                ? translate({
                                      namespace: 'login',
                                      key: 'reset_password.multiple_platforms_done',
                                      language,
                                  })
                                : translate({
                                      namespace: 'login',
                                      key: 'reset_password.done',
                                      params: { brand: branding.brand_name },
                                      language,
                                  })}
                        </AuthCardText>
                    </AuthCard>
                </AuthContent>

                <AuthFooter>
                    <LoginLink branding={branding} language={language} />
                </AuthFooter>
            </AuthContainer>
        </ThemeProvider>
    );
}
